import { render, staticRenderFns } from "./ReadCandidatJure.vue?vue&type=template&id=3c25cfa3&scoped=true"
import script from "./ReadCandidatJure.vue?vue&type=script&lang=js"
export * from "./ReadCandidatJure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25cfa3",
  null
  
)

export default component.exports